const initialState = {data: {}};

const reducer = ( state = initialState, action) =>
{
    switch (action.type) {
        case 'GET_STREAM_SUCCESS':
            return {data: action.data};
        default:
            return state;
    }
}
export default reducer;